import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { TimepickerInputComponent } from './timepicker.component';
import { TimepickerDirective } from './timepicker.direcive';
import { IonicModule } from '@ionic/angular';
import { FrontendDropdownModule } from '@tablesready/frontend-dropdown';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    IonicModule,
    FrontendDropdownModule,
  ],
  declarations: [TimepickerInputComponent, TimepickerDirective],
  exports: [TimepickerInputComponent],
})
export class TimepickerModule {}
